import type { AxiosError } from 'axios';

import type { HttpClientOptions } from '@main/http/http-client';
import { HttpClient } from '@main/http/http-client';
import { HttpRequestInterceptors } from '@main/http/http-request-interceptors';
import { idHttpClient } from '@main/http/id-http-client';
import type { IntegrationManagerClient } from '@usecases/get-signed-recording-url.usecase';

export class IntegrationManagerHttpClient
  extends HttpClient
  implements IntegrationManagerClient
{
  private static host = process.env.HOST;
  private static baseURl = `https://integrations-manager.${this.host}`;

  private static options: HttpClientOptions = {
    baseUrl: this.baseURl,
    retryConfig: {
      preRetryOp: this.preRetryOp,
      retryCondition: this.retryCondition,
    },
  };

  constructor() {
    super(IntegrationManagerHttpClient.options);
    this.axiosInstance.interceptors.request.use(
      HttpRequestInterceptors.addBearerTokenInterceptor,
    );
  }

  private static async preRetryOp(error: AxiosError) {
    const { response } = error;
    if (response && (response.status === 403 || response.status == 401)) {
      return idHttpClient.updateToken();
    }
  }

  private static retryCondition(error: AxiosError, retryCount: number) {
    const { message } = error;
    const { response } = error;

    const isNetworkError =
      message?.toLowerCase().includes('timeout') ||
      message?.toLowerCase().includes('network error');

    const isUnAuthenticated =
      (response?.status === 403 || response?.status == 401) && retryCount < 1;

    return isUnAuthenticated || isNetworkError;
  }

  async getrecordingUrlByCallId(recordingUrl: string): Promise<string> {
    try {
      const res = await this.get<string>(`${recordingUrl}`);

      return res;
    } catch (e) {
      console.log(e);
      return '';
    }
  }
}

export const integrationManagerHttpClient = new IntegrationManagerHttpClient();
